import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../web/components-v2/Theme/theme';
import { aidaBaseStyles } from '../../styles/styles';

export const styleSheet = StyleSheet.create({
	ghostsContainer: {
		...aidaBaseStyles.flexCol,
		alignItems: 'center',
		gap: SPACE[24],
	},
	text: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.md,
	},
	whoYaGonnaCallContainer: {
		...aidaBaseStyles.flexCenter,
		height: '100%',
		padding: SPACE[24],
		textAlign: 'center',
		width: '100%',
	},
});
